import React from 'react';
import ServiceTemplate from '@/components/ServiceTemplate';

const Sanitaires = () => {
  return (
    <ServiceTemplate
      title="Sanitaires"
      heroImage="https://images.unsplash.com/photo-1568564485646-8387cc48ed0e?w=1600"
      description="Installation d'équipements sanitaires modernes et fonctionnels pour votre confort quotidien."
      priceRange="3’000 - 12’000 CHF"
      duration="3-7 jours"
      features={[
        'Douche italienne sur mesure',
        'Baignoire îlot ou encastrée',
        'WC suspendu avec bâti support',
        'Vasques et lavabos design',
        'Robinetterie haut de gamme',
        'Installation par des professionnels qualifiés'
      ]}
      includes={[
        {
          title: 'Douche italienne',
          description: 'Installation de douche à l\'italienne avec receveur ou carreau'
        },
        {
          title: 'Baignoire',
          description: 'Pose de baignoire îlot, d\'angle ou encastrée'
        },
        {
          title: 'WC suspendu',
          description: 'Installation de WC suspendu avec bâti support caché'
        },
        {
          title: 'Vasques & Lavabos',
          description: 'Pose de vasques modernes avec meubles assortis'
        },
        {
          title: 'Robinetterie',
          description: 'Installation de robinets design et économiques en eau'
        },
        {
          title: 'Raccordements',
          description: 'Tous les raccordements plomberie inclus'
        }
      ]}
      benefits={[
        'Équipements modernes et design',
        'Amélioration du confort au quotidien',
        'Économies d\'eau avec robinetterie moderne',
        'Matériaux faciles d\'entretien',
        'Installation professionnelle et garantie',
        'Large choix de marques et de styles'
      ]}
    />
  );
};

export default Sanitaires;